<template>
  <DragDialog
    title="文件转换配置"
    :width="800"
    :visible.sync="visible"
    :footerBtn="['cancel', 'submit']"
    :submit="submit"
    :cancel="cancel">
    <div class="file-config-box">
      <div class="common-card-tabs-box">
        <el-tabs
          v-model="activeTab"
          class="tab-primary"
          type="card">
          <el-tab-pane
            v-if="isTabPaneVisible('rvt')"
            label="Revit"
            name="rvt">
            <div class="item-box tab-primary-item">
              <div class="label-box gr8 tab-primary-label">已选文件:</div>
              <div class="file-list-box disabled">
                <div
                  v-for="(item, index) in rvtFiles"
                  :key="index"
                  class="list-item-box">
                  <div class="file-name-box">
                    <div
                      class="circle"
                      v-if="rvtFiles.length > 1"></div>
                    <div
                      class="two-line-text-overflow"
                      :title="item.fileName">
                      {{ item.fileName }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="item-box tab-primary-item"
              v-if="isThreedViewVisible()">
              <div class="label-box gr8 tab-primary-label">三维视图:</div>
              <div class="common-select-box">
                <el-select
                  :popper-append-to-body="false"
                  class="primary-select"
                  size="small"
                  popper-class="primary-select-outer"
                  v-model="revitConfig.threed_view">
                  <el-option
                    v-for="(item, index) in threedviewList"
                    :key="index"
                    :label="item"
                    :value="item" />
                </el-select>
              </div>
            </div>
            <div
              class="threed-view-tips public-tips-primary"
              v-if="isThreedViewVisible()">
              默认选中上次转换使用的视图
            </div>
            <div class="general-config-title-box tab-primary-label">
              <span class="general-config-title-box-label">通用配置:</span>
              <div class="common-checkbox-box">
                <el-checkbox
                  class="checkbox-primary"
                  v-model="revitConfig.export_rooms">
                  导出房间和面积
                </el-checkbox>
                <el-checkbox
                  class="checkbox-primary"
                  v-model="revitConfig.section_valid">
                  是否应用剖面框
                </el-checkbox>
                <el-checkbox
                  class="checkbox-primary"
                  v-model="revitConfig.export_dwg"
                  @change="handleExportDwgChange">
                  导出二维图纸
                </el-checkbox>
              </div>
            </div>
            <!-- <div class="item-box tab-primary-item">
              <div class="label-box" />
              
            </div> -->
            <div
              class="item-box tab-primary-item"
              v-if="revitConfig.export_dwg && isUseViewSheet()">
              <div class="label-box gr8 tab-primary-label">二维图纸:</div>
              <div class="view-sheet-box common-tree-box">
                <el-tree
                  class="tree-primary"
                  ref="viewSheetTree"
                  :data="viewSheetData"
                  :props="defaultProps"
                  node-key="nodeId"
                  :indent="20"
                  show-checkbox
                  highlight-current
                  default-expand-all
                  :expand-on-click-node="false">
                  <template slot-scope="{ data }">
                    <div class="custom-node-box text-overflow">
                      {{ data.nodeName }}
                    </div>
                  </template>
                </el-tree>
              </div>
            </div>
            <div class="item-box tab-primary-item">
              <div class="sub-item-box">
                <div class="label-box tab-primary-label gr8">颜色:</div>
                <div class="common-select-box">
                  <el-select
                    class="primary-select"
                    :popper-append-to-body="false"
                    size="small"
                    popper-class="common-select-popper-box"
                    v-model="revitConfig.export_color">
                    <el-option
                      v-for="item in revitColorList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value" />
                  </el-select>
                </div>
              </div>
              <div class="sub-item-box">
                <div class="label-box tab-primary-label gr8">LOD:</div>
                <div class="common-select-box">
                  <el-select
                    class="primary-select"
                    :popper-append-to-body="false"
                    size="small"
                    popper-class="common-select-popper-box"
                    v-model="revitConfig.export_mesh_lod">
                    <el-option
                      v-for="item in revitLodList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value" />
                  </el-select>
                </div>
              </div>
            </div>
            <div class="item-box tab-primary-item">
              <div class="label-box tab-primary-label gr8">导出基点坐标</div>
              <div class="common-select-box custom-select-box">
                <el-select
                  class="primary-select"
                  :popper-append-to-body="false"
                  size="small"
                  popper-class="common-select-popper-box"
                  v-model="revitConfig.export_dump_type">
                  <el-option
                    v-for="item in revitDumpList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value" />
                </el-select>
              </div>
            </div>
            <div class="senior-config-title-box">
              <div class="label-box tab-primary-label gr8">
                <span class="label-box-text">高级选项:</span>
                <div class="common-checkbox-box">
                  <el-checkbox
                    class="checkbox-primary"
                    v-model="revitConfig.export_grid_level">
                    导出轴网标高
                  </el-checkbox>
                  <el-checkbox
                    class="checkbox-primary"
                    v-model="revitConfig.export_view_imgs">
                    导出二维视图
                  </el-checkbox>
                  <el-checkbox
                    class="checkbox-primary"
                    v-model="revitConfig.export_detail_xmls">
                    导出明细表
                  </el-checkbox>
                  <el-checkbox
                    class="checkbox-primary"
                    v-model="revitConfig.export_hid_elements">
                    导出隐藏构件
                  </el-checkbox>
                </div>
              </div>
              <!-- <div class="icon-box" @click="toggleSeniorConfigVisible">
                <i v-if="isSeniorConfigVisible" class="el-icon-arrow-up" />
                <i v-else class="el-icon-arrow-down" />
              </div> -->
            </div>
            <!-- <div v-if="isSeniorConfigVisible" class="item-box tab-primary-item">
              <div class="label-box"></div>
              
            </div> -->
            <div class="item-box tab-primary-item">
              <div class="label-box tab-primary-label gr8">零件可见性:</div>
              <div class="common-select-box custom-select-box">
                <el-select
                  class="primary-select"
                  size="small"
                  popper-class="primary-select-outer"
                  v-model="revitConfig.export_part_visible">
                  <el-option
                    v-for="item in revitExportPartTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value" />
                </el-select>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane
            v-if="isTabPaneVisible('3dxml')"
            label="3DXML"
            name="3dxml">
            <div class="item-box">
              <div class="label-box tab-primary-label">单位缩放比例:</div>
              <div class="common-input-box">
                <span class="tab-primary-label">1单位 = </span>
                <el-input-number
                  class="input-primary"
                  controls-position="right"
                  size="mini"
                  v-model="xml3DConfig.unitRatio"
                  :min="0"
                  :step="0.001" />
                <span
                  class="tab-primary-label"
                  style="margin-left: 10px"
                  >m</span
                >
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane
            v-if="isTabPaneVisible('3dm')"
            label="3dm"
            name="3dm">
            <div class="item-box">
              <div class="label-box tab-primary-label dm3-label-box">
                导出模式:
              </div>
              <div class="common-radio-box">
                <el-radio-group
                  v-model="dm3Config.bRenderModel"
                  class="radio-primary">
                  <el-radio :label="false">着色模式</el-radio>
                  <el-radio :label="true">渲染模式</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="item-box">
              <div class="label-box tab-primary-label dm3-label-box">
                是否导出关闭图层:
              </div>
              <div class="common-radio-box">
                <el-radio-group
                  v-model="dm3Config.bShowOffLayer"
                  class="radio-primary">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane
            v-if="isTabPaneVisible('skp')"
            label="skp"
            name="skp">
            <div class="item-box">
              <div class="label-box skp-label-box tab-primary-label">
                是否导出隐藏图形:
              </div>
              <div class="common-radio-box">
                <el-radio-group
                  v-model="skpConfig.bExportHiddenGeometry"
                  class="radio-primary">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div
        class="common-switch-box"
        v-if="isCoveredVisible()">
        <div class="tips-label gr16 tab-primary-label">保留单文件配置</div>
        <el-switch
          v-model="isCovered"
          class="switch-primary"></el-switch>
        <div class="tips public-tips-primary">
          若已选文件已经单独做过配置，则保留单文件配置；若关闭，则当前配置将覆盖所有已选文件。
        </div>
      </div>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from '@/components/CustomDragDialog.vue'

import {
  getProjConvertConfigService,
  getThreedviewService,
  getViewSheetService
} from '@/service/interface'

export default {
  data() {
    return {
      activeTab: '',
      rvtFiles: [],
      threedviewList: [],
      viewSheetData: [],
      defaultProps: {
        children: 'subNodes',
        label: 'nodeName'
      },
      revitConfig: {
        ignore_textures_hint: true,
        open_outputdir: false,
        export_grid_level: true,
        section_valid: false,
        export_color: 1,
        export_mesh_lod: 2,
        threed_view: '',
        viewsheets: [],
        export_rooms: true,
        export_dump_type: 1,
        export_view_imgs: false,
        export_detail_xmls: false,
        export_hid_elements: false,
        export_part_visible: 0,
        export_dwg: false
      },
      isSeniorConfigVisible: true,
      revitColorList: [
        { value: 1, label: '真实' },
        { value: 2, label: '着色' },
        { value: 3, label: '混合着色' }
      ],
      revitLodList: [
        { value: 1, label: '低' },
        { value: 2, label: '中(推荐)' },
        { value: 3, label: '高' }
      ],
      revitDumpList: [
        { value: 0, label: '测量点' },
        { value: 1, label: '基点' },
        { value: 2, label: '内部原点' }
      ],
      revitExportPartTypeList: [
        { value: 0, label: '按零件导出' },
        { value: 1, label: '按原状态导出' },
        { value: 2, label: '按两者导出' },
        { value: 3, label: '按文件配置导出' }
      ],

      xml3DFiles: [],
      xml3DConfig: {
        unitRatio: 0.001,
        bDeleteRedundancyTreeNode: false
      },

      dm3Files: [],
      dm3Config: {
        bRenderModel: false,
        bShowOffLayer: false
      },

      skpFiles: [],
      skpConfig: {
        bExportHiddenGeometry: false
      },

      isCovered: true
    }
  },
  props: {
    visible: Boolean,
    fileConfigInfo: Object,
    submitConfig: Function,
    cancelConfig: Function
  },
  components: {
    DragDialog
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.initConfig()
      }
    }
  },
  methods: {
    initConfig() {
      this.activeTab = this.getActiveTab()
      this.initConfigFiles()

      if (this.fileConfigInfo.isGetProjConfig) {
        this.initConfigByProj()
      } else {
        this.initConfigByDefault()
      }
    },
    // 初始化需要配置的文件
    initConfigFiles() {
      for (let key in this.fileConfigInfo) {
        if (key === 'rvt') {
          this.rvtFiles = this.fileConfigInfo[key]
        }

        if (key === '3dxml') {
          this.xml3DFiles = this.fileConfigInfo[key]
        }

        if (key === '3dm') {
          this.dm3Files = this.fileConfigInfo[key]
        }

        if (key === 'skp') {
          this.skpFiles = this.fileConfigInfo[key]
        }
      }
    },
    // 根据文件历史转换参数初始化配置
    initConfigByDefault() {
      this.initThreedView().then(() => {
        this.initViewSheetData().then(() => {
          for (let key in this.fileConfigInfo) {
            if (key === 'rvt') {
              if (this.rvtFiles.length === 1) {
                let rvtFileInfo = this.rvtFiles[0]
                let revitConfig = rvtFileInfo.config
                if (revitConfig) {
                  this.revitConfig = {
                    ignore_textures_hint: revitConfig.ignore_textures_hint,
                    open_outputdir: revitConfig.open_outputdir,
                    export_grid_level: revitConfig.export_grid_level,
                    section_valid: revitConfig.section_valid,
                    export_color: revitConfig.export_color,
                    export_mesh_lod: revitConfig.export_mesh_lod,
                    threed_view: revitConfig.threed_view,
                    viewsheets: revitConfig.viewsheets.map(el => String(el)),
                    export_rooms: revitConfig.export_rooms,
                    export_dump_type: revitConfig.export_dump_type,
                    export_view_imgs: revitConfig.export_view_imgs,
                    export_detail_xmls: revitConfig.export_detail_xmls,
                    export_hid_elements: revitConfig.export_hid_elements,
                    export_part_visible: revitConfig.export_part_visible,
                    export_dwg: revitConfig.export_dwg
                  }

                  if (this.isUseViewSheet()) {
                    this.$nextTick(() => {
                      let domRef = this.$refs.viewSheetTree
                      if (domRef) {
                        let checkedKeys = revitConfig.viewsheets
                        domRef.setCheckedKeys(checkedKeys)
                      }
                    })
                  }
                } else {
                  this.revitConfig.threed_view = this.threedviewList[0]
                }
              }
            }

            if (key === '3dxml') {
              if (this.xml3DFiles.length === 1) {
                let xml3DFileInfo = this.xml3DFiles[0]
                let xml3DConfig = xml3DFileInfo.config
                if (xml3DConfig) {
                  this.xml3DConfig = {
                    unitRatio: xml3DConfig.unitRatio,
                    bDeleteRedundancyTreeNode:
                      xml3DConfig.bDeleteRedundancyTreeNode
                        ? xml3DConfig.bDeleteRedundancyTreeNode
                        : false
                  }
                }
              }
            }

            if (key === '3dm') {
              if (this.dm3Files.length === 1) {
                let dm3FileInfo = this.dm3Files[0]
                let dm3Config = dm3FileInfo.config
                if (dm3Config) {
                  this.dm3Config = {
                    bRenderModel: dm3Config.bRenderModel,
                    bShowOffLayer: dm3Config.bShowOffLayer
                  }
                }
              }
            }

            if (key === 'skp') {
              if (this.skpFiles.length === 1) {
                let skpFileInfo = this.skpFiles[0]
                let skpConfig = skpFileInfo.config
                if (skpConfig) {
                  this.skpConfig = {
                    bExportHiddenGeometry: skpConfig.bExportHiddenGeometry
                  }
                }
              }
            }
          }
        })
      })
    },
    initThreedView() {
      return new Promise(resolve => {
        if (!this.fileConfigInfo.rvt) {
          resolve()
          return
        }

        let promiseArray = []
        let rvtFiles = this.fileConfigInfo.rvt
        rvtFiles.forEach(file => {
          let promise = this.getThreeDviewByFile(file)
          promiseArray.push(promise)
        })

        Promise.all(promiseArray).then(() => {
          if (this.isThreedViewVisible()) {
            let rvtInfo = rvtFiles[0]
            let threedviewList = rvtInfo.threedviewList
            this.threedviewList = threedviewList
          }
          resolve()
        })
      })
    },
    initViewSheetData() {
      return new Promise(resolve => {
        if (!this.isUseViewSheet()) {
          resolve()
          return
        }

        let rvtInfo = this.rvtFiles[0]
        let params = { fileId: rvtInfo.fileId }
        getViewSheetService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            if (data && data.length) {
              let viewSheets = data.map(item => {
                let obj = {
                  nodeId: item.key,
                  nodeName: item.value
                }
                return obj
              })
              let viewSheetData = [
                {
                  nodeId: 'all',
                  nodeName: '全部图纸',
                  subNodes: viewSheets
                }
              ]
              this.viewSheetData = viewSheetData
            }
            resolve()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    isUseViewSheet() {
      let visible = false

      if (window.isCheckViewSheet) {
        visible = true
      }

      if (visible && !this.fileConfigInfo.isLinkModel) {
        visible = true
      } else {
        visible = false
      }

      if (visible && !this.fileConfigInfo.isBatchConfig) {
        visible = true
      } else {
        visible = false
      }

      let rvtFiles = this.rvtFiles
      if (visible && rvtFiles.length === 1) {
        visible = true
      } else {
        visible = false
      }

      return visible
    },
    getThreeDviewByFile(file) {
      return new Promise(resolve => {
        getThreedviewService({ fileId: file.fileId }).then(response => {
          if (response.isSuccess) {
            let data = response.data
            file.threedviewList = data
            resolve()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    // 根据项目转换参数初始化配置
    initConfigByProj() {
      let projId = this.$route.params.projId
      getProjConvertConfigService(projId).then(response => {
        if (response.isSuccess) {
          let data = response.data
          if (data) {
            data = JSON.parse(data)
            let revitConfig = data.RevitConfig
            let threed_view = this.revitConfig.threed_view
            this.revitConfig = {
              ignore_textures_hint: revitConfig.ignore_textures_hint,
              open_outputdir: revitConfig.open_outputdir,
              export_grid_level: revitConfig.export_grid_level,
              section_valid: revitConfig.section_valid,
              export_color: revitConfig.export_color,
              export_mesh_lod: revitConfig.export_mesh_lod,
              threed_view: revitConfig.ThreedView
                ? revitConfig.ThreedView
                : threed_view,
              viewsheets: revitConfig.viewsheets,
              export_rooms: revitConfig.export_rooms,
              export_dump_type: revitConfig.export_dump_type,
              export_view_imgs: revitConfig.export_view_imgs,
              export_detail_xmls: revitConfig.export_detail_xmls,
              export_hid_elements: revitConfig.export_hid_elements,
              export_part_visible: revitConfig.export_part_visible,
              export_dwg: revitConfig.export_dwg
            }

            let xml3DConfig = data.Xml3DConfig
            this.xml3DConfig = {
              unitRatio: xml3DConfig.unitRatio,
              bDeleteRedundancyTreeNode: xml3DConfig.bDeleteRedundancyTreeNode
                ? xml3DConfig.bDeleteRedundancyTreeNode
                : false
            }

            let dm3Config = data.Dm3Config
            this.dm3Config = {
              bRenderModel: dm3Config.bRenderModel,
              bShowOffLayer: dm3Config.bShowOffLayer
            }

            let skpConfig = data.SketchUpConfig
            this.skpConfig = {
              bExportHiddenGeometry: skpConfig.bExportHiddenGeometry
            }
          }
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    handleExportDwgChange(checked) {
      if (checked) {
        let revitConfig = this.revitConfig
        let checkedKeys = revitConfig.viewsheets

        this.$nextTick(() => {
          let domRef = this.$refs.viewSheetTree
          if (domRef) {
            if (!checkedKeys.length) {
              let viewSheetData = this.viewSheetData[0]
                ? this.viewSheetData[0].subNodes
                : []
              checkedKeys = viewSheetData.map(el => el.nodeId)
              domRef.setCheckedKeys(checkedKeys)
            } else {
              domRef.setCheckedKeys(checkedKeys)
            }
          }
        })
      }
    },
    toggleSeniorConfigVisible() {
      this.isSeniorConfigVisible = !this.isSeniorConfigVisible
    },
    submit() {
      let fileConfigInfo = this.fileConfigInfo
      // prettier-ignore
      if (window.isCheckThreeView && !fileConfigInfo.isBatchConfig && !fileConfigInfo.isLinkModel) {
        if (this.rvtFiles.length) {
          let invalidRvtFiles = this.getInvalidRvtFiles(this.rvtFiles);
          if (invalidRvtFiles.length) {
            let invalidRvtFileNames = invalidRvtFiles.map((el) => el.fileName);
            invalidRvtFileNames = invalidRvtFileNames.join(",");
            let errMsg = `${invalidRvtFileNames}无三维视图信息，请在相应建模软件添加后重新上传`;
            this.$message.error(errMsg);

            this.cancel();
          } else {
            if (this.isThreedViewEmpty()) {
              this.$message.warning("请选择三维视图信息");
              return;
            }
          }
        }
      }

      let params = {}
      params['revitModelFiles'] = this.rvtFiles.map(el => el.fileId)
      if (window.isCheckViewSheet && this.rvtFiles.length === 1) {
        let domRef = this.$refs.viewSheetTree
        if (domRef) {
          let checkedNodes = domRef.getCheckedNodes()
          checkedNodes = checkedNodes.filter(el => el.nodeId !== 'all')
          let viewsheets = checkedNodes.map(el => el.nodeId)
          this.revitConfig.viewsheets = viewsheets
        }
      }

      if (this.revitConfig.export_dwg && this.viewSheetData.length) {
        if (!this.revitConfig.viewsheets.length) {
          this.$message.warning('请勾选需要导出的二维图纸')
          return
        }
      }

      if (!this.revitConfig.export_dwg) {
        this.revitConfig.viewsheets = []
      }
      params['revitConfig'] = this.revitConfig

      params['xml3DModelFiles'] = this.xml3DFiles.map(el => el.fileId)
      params['xml3DConfig'] = this.xml3DConfig

      params['dm3ModelFiles'] = this.dm3Files.map(el => el.fileId)
      params['dm3Config'] = this.dm3Config

      params['sketchUpFiles'] = this.skpFiles.map(el => el.fileId)
      params['sketchUpConfig'] = this.skpConfig

      if (fileConfigInfo.isBatchConfig) {
        params['isCovered'] = this.isCovered
      }

      this.submitConfig(params)
      this.clearForm()
    },
    // 校验三维视图是否选择
    isThreedViewEmpty() {
      let rvtFiles = this.rvtFiles
      let isModelManage = this.fileConfigInfo.isModelManage
      let threed_view = this.revitConfig.threed_view
      let isEmpty = false
      if (isModelManage && rvtFiles.length === 1 && !threed_view.length) {
        isEmpty = true
      }
      return isEmpty
    },
    cancel() {
      this.clearForm()
      this.cancelConfig()
    },
    getInvalidRvtFiles(rvtFiles) {
      if (rvtFiles && this.isThreedViewVisible()) {
        let invalidFiles = rvtFiles.filter(el => !el.threedviewList.length)
        return invalidFiles
      } else {
        return []
      }
    },
    isTabPaneVisible(tabName) {
      if (this.fileConfigInfo[tabName]) {
        return true
      } else {
        return false
      }
    },
    getActiveTab() {
      const tabNamesArray = ['rvt', '3dxml', '3dm', 'skp']
      let fileConfigKeys = Object.keys(this.fileConfigInfo)
      let findIndex = tabNamesArray.findIndex(el => fileConfigKeys.includes(el))
      let activeTab = tabNamesArray[findIndex]
      return activeTab
    },
    isThreedViewVisible() {
      let visible = false
      if (window.isCheckThreeView) {
        visible = true
      }

      if (visible && this.fileConfigInfo.isModelManage) {
        visible = true
      } else {
        visible = false
      }

      if (visible && !this.fileConfigInfo.isLinkModel) {
        visible = true
      } else {
        visible = false
      }

      if (visible && !this.fileConfigInfo.isBatchConfig) {
        visible = true
      } else {
        visible = false
      }

      let rvtFiles = this.rvtFiles
      if (visible && rvtFiles.length === 1) {
        visible = true
      } else {
        visible = false
      }

      return visible
    },
    isCoveredVisible() {
      let isModelManage = this.fileConfigInfo.isModelManage
      let isCoveredVisible = this.fileConfigInfo.isCoveredVisible

      return isCoveredVisible && isModelManage
    },
    clearForm() {
      this.activeTab = ''
      this.rvtFiles = []
      this.threedviewList = []
      this.viewSheetData = []
      this.revitConfig = {
        ignore_textures_hint: true,
        open_outputdir: false,
        export_grid_level: true,
        section_valid: false,
        export_color: 1,
        export_mesh_lod: 2,
        threed_view: '',
        viewsheets: [],
        export_rooms: true,
        export_dump_type: 2,
        export_view_imgs: false,
        export_detail_xmls: false,
        export_hid_elements: false,
        export_part_visible: 0,
        export_dwg: false
      }
      this.isSeniorConfigVisible = true

      this.xml3DFiles = []
      this.xml3DConfig = {
        unitRatio: 0.001,
        bDeleteRedundancyTreeNode: false
      }

      this.dm3Files = []
      this.dm3Config = {
        bRenderModel: false,
        bShowOffLayer: false
      }

      this.skpFiles = []
      this.skpConfig = {
        bExportHiddenGeometry: false
      }

      this.isCovered = true
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.file-config-box {
  color: var(--default-color);
  max-height: 590px;

  .tab-primary {
    :deep(.el-tabs__content) {
      overflow: visible;
      margin-top: 16px;
    }
  }

  .item-box {
    display: flex;
    align-items: center;
    margin: 16px 0px;

    &:first-child {
      margin-top: 0px;
    }

    &:last-child {
      margin-bottom: 0px;
    }

    .label-box {
      width: 92px;
      text-align: right;
      flex-shrink: 0;
      line-height: 32px;
    }

    .dm3-label-box {
      width: 120px;
    }

    .skp-label-box {
      width: 150px;
    }

    .file-list-box {
      flex-grow: 1;
      max-height: 80px;
      // margin-left: 10px;
      padding: 4px 15px;
      border-radius: 4px;
      border: 1px solid #444444;
      background: #2c2c2c;
      overflow-y: auto;

      .list-item-box {
        margin: 10px 0px;

        &:first-child {
          margin-top: 0px;
        }

        &:last-child {
          margin-bottom: 0px;
        }

        .file-name-box {
          display: flex;

          .circle {
            width: 5px;
            height: 5px;
            background: var(--default-color);
            margin: auto 10px auto 0px;
            border-radius: 50%;
          }

          .two-line-text-overflow {
            font-size: 14px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            line-height: 1.5em;
          }
        }
      }
    }

    .view-sheet-box {
      flex-grow: 1;
      max-height: 150px;
      padding: 10px;
      font-size: 14px;
      border-radius: 4px;
      border: 1px solid var(--bimview-list-fileChange-border-color);
      background: var(--bimview-list-fileChange-bgColor);
      overflow-y: auto;
    }

    .common-select-box {
      // margin-left: 10px;
      flex-grow: 1;

      .el-select {
        width: 100%;
      }
    }

    .custom-select-box {
      width: 215px;
      flex-grow: unset;
    }

    .common-checkbox-box {
      margin-left: 10px;
      flex-grow: 1;

      .el-checkbox {
        width: 120px;
      }
    }

    .common-input-box {
      margin-left: 10px;
      line-height: 32px;
    }

    .common-radio-box {
      margin-left: 10px;
      line-height: 32px;
    }

    .sub-item-box {
      display: flex;
    }

    .common-input-box {
      line-height: 32px;
    }
  }

  .threed-view-tips {
    margin-top: -13px;
    margin-left: 104px;
    font-size: 12px;
  }

  .general-config-title-box {
    width: 100%;
    text-align: right;
    flex-shrink: 0;
    margin-bottom: 6px;
    display: flex;
    justify-content: flex-start;
    margin-top: 6px;

    &-label {
      flex-basis: 92px;
      margin-right: 10px;
    }
  }

  .senior-config-title-box {
    display: flex;

    .label-box {
      text-align: right;
      flex-shrink: 0;
      line-height: 32px;
      display: flex;
      justify-content: flex-start;
      width: 100%;

      &-text {
        flex-basis: 92px;
        margin-right: 10px;
      }

      .common-checkbox-box {
        display: flex;
        justify-content: flex-start;
      }
    }

    .icon-box {
      margin: auto 10px;
      cursor: pointer;
    }
  }

  .common-switch-box {
    display: flex;
    margin-top: 10px;

    .tips-label {
      width: 130px;
      text-align: right;
    }

    .tips {
      font-size: 12px;
      margin-left: 5px;
      line-height: 20px;
      color: #a3a19d;
    }
  }
}
</style>
